const worldContent = String.raw`
# 세계관

## 영운설화

수 천년 전 영운에는 시간을 나누어 다스리던 두 존재가 있었다.
하나는 지나간 시간을, 다른 하나는 다가올 시간을 노래하였다.
그러던 어느 날, 두 존재는 '안정'과 '변화'를 두고 다투었고
싸움에 하늘은 갈라지고 대지는 불탔다.
쌓아온 추억과 다가올 희망이 바스라질 즈음, 영운의 수호신이 나타나 말했다.
"흘러간 날도, 오지 않은 날도⸻ 모두 지금 이 순간 하나의 흐름일 뿐."
그러곤 두 존재를 진정 시켜 그들을 깊은 산맥 속으로 잠들게 한 뒤
불타버린 잿빛 대지를 다시 초록빛으로 물들이고 자취를 감추었다.
그날 이후, 시간의 흐름은 신의 의지가 아닌 영운의 사람들에게 맡겨졌다고 전해진다.
===⸻ 영운 설화 中===

## 15년 전 영운지방

### 악의 조직 크로노스

크로노스는 영운의 번영과 미래를 앞세워 사람들의 포켓몬을 빼앗고 야생 포켓몬을 밀렵하는 등 여러 범죄를 일삼았으나 어느 한 10대 트레이너에게 붕괴해 15년 전 완전히 해체되었다.

### 포켓몬 리그 토너먼트

매해 체육관 배지 8개를 모두 획득한 포켓몬 트레이너들을 대상으로 포켓몬 리그가 개최되었다. ==리그는 토너먼트== 형식으로 진행되었으며, 사천왕 및 체육관 관장에게 시드권이 부여되었다. 결승전까지 오른 트레이너는 도전자의 자격으로 챔피언과의 배틀이 이루어졌고, ==도전자가 승리했을 시 새로운 챔피언이 되었다.==

당시 영운지방 포켓몬 리그는 모두가 열광하여 관중석 티켓은 언제나 전석 매진이었고, 모든 포켓몬 트레이너는 리그 배틀코트에 서는 것이 꿈이자, 목표였다.

### 대지진

포켓몬 리그의 위치가 이전되는 직접적인 계기로 ==15년 전, 새로운 챔피언이 탄생한 직후 영운지방 전역에 원인을 알 수 없는 대지진이 발생==하였다. 지진은 지방 전역을 뒤흔들었고, 수많은 포켓몬과 사람들이 목숨을 잃거나 크게 다치고 말았다. 시간이 흘러 상처가 아물 듯 현재는 대부분의 물리적 흔적은 사라졌으나, 당시의 참혹한 상황은 여전히 많은 사람의 기억 속에 깊은 상흔으로 남아 있다.

^^주 피해 지역: 여명섬 · 음현시티 · 화련타운^^

## 현재의 영운지방
![news](/newspaper.png =700)
대지진 이후 여행을 떠나는 트레이너의 수가 감소하였고, 이에 따라 엘리트 트레이너의 수 또한 줄어들었다. 그 결과 영운지방의 포켓몬 리그는 점차 쇠퇴하여 다른 지방에 비해 약세를 보이게 되었고 기존 리그 운영 방식을 유지하기 어려운 상황에 이르렀다. 결국 포켓몬 리그는 리그 시스템 개편과 함께 ==랭크제를 도입==해 기존 '포켓몬 챔피언' 직책은 =='치프 챔피언'==으로 개칭되었다.

### 랭크 시스템

8개의 배지를 획득한 트레이너는 별도의 토너먼트 없이 사천왕에게 도전할 수 있다. 사천왕을 모두 격파한 트레이너는 =='챔피언 랭크'==를 부여받게 된다. 이후 챔피언 랭크의 트레이너는 최종적으로 '치프 챔피언'에게 도전할 수 있으며, 해당 도전에서 승리할 경우 '치프 챔피언'의 지위를 계승하게 된다.

### 현 치프 챔피언

영운지방 최강의 트레이너이자, 현재 포켓몬 리그 시스템을 개편한 리그위원장이며 15년 전 대지진 발생 직전 과거 리그에서 최종 우승하여 챔피언 자리에 오른 장본인이기도 하다. 대지진 이후 재해 복구 및 지방 안정화에 전념하였고 현재는 구 챔피언로드 지역 탐사 업무를 주로 담당하고 있다. 이로 인해 공식적인 리그 활동에는 자주 모습을 드러내지 않는다. 또한 매스컴 노출을 꺼리는 성향으로 인해 그의 정체를 아는 이는 극소수에 불과하다.

영운지방의 안정에 핵심적인 역할을 수행하고 있으나, 본래 역할인 리그 활성화에 소홀해지면서 일부에서는 이에 대한 불만도 존재한다.

### 구 챔피언 로드 여명섬

과거 포켓몬 리그가 있던 장소로, 15년 전 대지진 이후 큰 생태 변화가 발생해 현재는 사람이 살 수 없는 지역이 되었다. 위험한 포켓몬들이 공격해오거나 지형이 험난한 탓에 실력이 충분하지 못한 트레이너는 접근조차 어렵다. 지역 복구를 위해 포켓몬 리그 주도하에 꾸준히 탐사와 관측을 진행하고 있으나 아직까지 뚜렷한 진전은 없다. 많은 전문가들은 중심부에서 관측되는 강력한 에너지를 근거로, 이것이 현상의 원인일 것이라고 추측하고 있다.

## 영운지방 지도

![map](/yeongwun-map.png =700)

### 상오마을
* ===박사 연구소 · 유적지===
트레이너 육성 캠프 오리엔테이션이 열리는 마을로, 박사의 연구소가 위치해 있다. 마을 뒤편에는 과거 어떤 포켓몬을 모신 것으로 추정되는 제단의 흔적이 남아 있어 영운지방 신화가 시작된 장소로 여겨지고 있다. 전반적으로 조용하고 평화로운 분위기를 지닌 마을이다.

### 청류타운
* ===청류 체육관 · 유명 맛집===
영운지방 최대 하천인 영도강의 발원지이자 최대의 곡창지대이다. 주민 대부분이 농업 관련 직종에 종사하고 있으며, ‘미식의 시발점’이라는 별명답게 청류타운의 음식은 영운지방에서도 손꼽히는 맛을 자랑한다.


### 노은마을
* ===바람전망 언덕 · 노은 방앗간 · 노은 해수욕장===
청류타운 북쪽 산을 넘어 나타나는 조용한 해안 마을로, 여행 중 쉬어가기 좋은 역참 역할을 한다. 청류타운에서 들여온 질 좋은 곡물로 만든 ‘오란다’가 지역 특산품이다.


### 해륙시티
* ===도란등대 · 해륙 무역항 · 해륙 체육관===
영운지방 제2의 도시이자 가장 큰 항구도시로  깨비드릴조 택시를 운영하는 「영운 교통」 회사의 본사가 위치해있다. 타지방에서 수입되는 대부분의 물품이 해륙항을 통해 들어오기 때문에 많은 무역회사가 밀집한 상업 중심지이기도 하다.

### 시유림
* ===시간의 연못===
영운지방의 수호신이 만들었다는 전설이 전해지는 원시림이다. ‘모든 시간을 품은 숲’이라는 이름처럼 오래된 거목이 가득하며, 희귀한 버섯과 약초가 많다. 단, 지정된 길을 벗어나면 길을 잃기 쉬워 주의가 필요하다. 
^^출신지 설정 불가 지역^^

###  청호마을
* ===청호 체육관 · 키우미 집 · 청호호수===
영운지방에서 가장 큰 호수가 위치한 휴양 마을로, 호숫길을 따라 펼쳐지는 넓은 꽃농원이 유명하다. 여름철에는 특히 버베나 꽃밭이 장관을 이루며, 이를 이용한 버베나 향수가 지역 특산품으로 판매된다.


###  탄풍타운
* ===절벽의 약속바위 · 화석 포켓몬 사파리 · 탄풍 체육관===
과거 탄광 마을이었으나 폐광으로 쇠퇴하던 중, 화석 발굴을 계기로 복원 사업이 진행되며 ‘화석 사파리’가 개장해 다시 활기를 되찾았다. 거친 지형과 암벽산이 많아 산악인과 모험가들에게 인기 있는 지역이며, 레인저 본부가 이곳에 자리하고 있다.

###  설백타운
* ===사우나 거리 · 설백호수 · 설백 체육관 · 메리프 목장===
사방이 산맥으로 둘러싸인 영운지방 최북단의 추운 지역으로,  사우나 문화가 발달해 있으며, 온천이 유명한 화련타운과 ‘누가 더 최고인지’를 두고 경쟁하는 것으로 알려져 있다. 겨울철에는 바닥이 보일 정도로 투명하게 어는 호수가 명소로 꼽힌다.


### 운담마을
* ===은월다리 · 추모탑===
안개가 잦은 고요한 골짜기 마을이다. 고스트·에스퍼 타입 포켓몬이 흔하게 출몰하는 지역으로 보름달이 뜨는 날 안개가 낄 때 마을의 다리를 건너면 그리운 포켓몬의 얼굴을 볼 수 있다는 전설과 함께 먼저 떠나간 포켓몬을 추모하는 탑이 있다. 

### 도광시티
* ===영도강변 공원 · 포켓몬 콘테스트 홀 · 도광 체육관 · 도광타워===
청류타운에서 발원한 영도강의 중류가 도시 중심을 가로지르며, 영운지방 최대의 대도시이자 기술·패션·문화의 중심지이다. 주요 방송국이 몰려 있으며 올해의 코디네이터를 선발하는 그랜드 포켓몬 콘테스트가 열리는 도시로도 유명하다. 

### 화련타운
* ===온천 · 화련 체육관 · 제련 산업 단지===
15년 전 대지진의 최대 피해 지역 중 하나였으나 완전한 재건을 이뤄 ‘극복의 상징’으로 여겨진다. 풍부한 지열을 활용한 온천과 불꽃 포켓몬과 협동하여 뛰어난 제련 기술로 유명해 관련 장인들이 모여 사는 지역이다.

###  음현시티
* ===IT 산업단지 · 지하도시 쇼핑몰 · 음현 체육관===
대지진 당시 큰 피해를 입고 오랫동안 치안이 불안한 도시였으나, 한 보안기술 회사 CEO의 대규모 재건 사업 이후 급속도로 성장해 현재는 영운지방 3대 도시로 자리 잡았다. IT 산업의 중심지이며, 과거 불법도박장과 포켓몬 암시장이 있던 지하시설은 도시 속 또 다른 지하도시로 리뉴얼 되었다.

### 여명섬
과거 포켓몬 리그와 더불어 시유림과 유사한 원시림인 회시림이 존재했으나 대지진 당시 가장 큰 피해를 보았으며, 이후 극단적인 생태 변화가 발생했다. 정상적인 접근조차 어려우며, 사람이 거주할 수 없는 곳이 되었다. 현재 이곳에 상주하는 주민은 없고, 포켓몬 리그와 챔피언의 주도 아래 정기적인 탐사만이 이루어지고 있다. 

### 포켓몬 리그
대지진 이후 조성된 인공섬으로, 여명섬으로 향하는 유일한 길목이다. 이곳에는 현재 ==챔피언 로드와 포켓몬 리그==가 위치해 있으며, 리그의 허가 없이는 여명섬으로의 출입이 엄격히 제한되어 있다.
^^출신지 설정 불가 지역^^


%% ⓒ2026 · 포켓몬스터 오리진 비욘드`;

export default worldContent;
